import React from "react";
import { Alert, Button } from "@mui/material";

export default function AnticonCaptureControls({ capture, role, canWrite }) {
  return <>
    {!capture.qa.enabled && <Alert severity="warning">{capture.qa.reason}</Alert>}
    {!canWrite && role && <Alert severity="info">Consulta únicamente para este registro.</Alert>}
    {capture.notice && <Alert severity={capture.notice.severity}>{capture.notice.text}</Alert>}
    {capture.conflict && capture.record && <Button onClick={() => capture.open(capture.record.id)}>Recuperar versión actual</Button>}
    {capture.uncertain && <Alert severity="warning" action={<Button onClick={capture.retry} disabled={capture.busy}>Reintentar guardado</Button>}>
      No se pudo confirmar el guardado. Los cambios se conservan.
    </Alert>}
  </>;
}
